module.exports = __webpack_public_path__ + "img/shipping.b36f7f92.svg";